import React, { useState } from "react";

//UI Material
import { Button, Chip, Grid, Stack } from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForMainTitles,
  typographyForText,
} from "../../Helpers/typography";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { generateStatusName } from "../../Helpers/orderFunctions";

export default function ProductSummary({ data }) {
  // ==========>Component States<==========
  const [showDetails, setShowDetails] = useState(false);

  // ==========>Component<==========
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={1} textAlign="left">
          <Grid item xs={12}>
            <Stack
              justifyContent="flex-start"
              alignItems="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "Nombre del producto",
                "11px",
                "null",
                "bold"
              )}
              {typographyForMainTitles(data.aditionalData.productName)}
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Chip
              label={typographyForText(`Producto ${data.productId}`)}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12}>
            <Stack
              justifyContent="flex-start"
              alignItems="flex-start"
              textAlign="left"
            >
              {typographyForCustomizedFontSize(
                "ID de la orden",
                "11px",
                "null",
                "bold"
              )}
              {typographyForText(
                `Orden ${data.productId.slice(0, data.productId.indexOf("-"))}`
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Button
              sx={{ fontSize: "10px" }}
              color="secondary"
              size="small"
              startIcon={
                !showDetails ? <KeyboardArrowDown /> : <KeyboardArrowUp />
              }
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails ? "ver menos información" : "ver más información"}
            </Button>
          </Grid>

          {showDetails && (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Stack
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    textAlign="left"
                  >
                    {typographyForCustomizedFontSize(
                      "Estado de la orden",
                      "11px",
                      "null",
                      "bold"
                    )}
                    {typographyForText(generateStatusName(data.status))}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
